import ChatBot from '../Chatbot/ChatBot';
import ImageSelection from '../ImageSelection';
import '../CreacionTexto.css';
import { useTranslation } from 'react-i18next';
import TextPromptAvatar from './TextPromptAvatar';

const CreacionTextoAvatar = () => {
    const { t } = useTranslation();

    const heading = t('Paso 3');
    const subtitle = t('Escribir');
    const description = t('Descripción');

    return (
        <div className="componente-superior">
            <div className="columna-izquierda">
                {/* Aquí podrías incluir el formulario de selección de imágenes o cualquier otro contenido */}
                <ImageSelection heading={heading} subtitle={subtitle} description={description} />
                <ChatBot />
            </div>
            <div className='columna'>
                {/* Asegúrate de que cada prop sea pasada correctamente y que todos los corchetes estén cerrados */}
                <TextPromptAvatar />
            </div>
            {/* Asegúrate de que mainImage y thumbnails sean pasados correctamente a ImageResult */}
        </div>
    );
};

export default CreacionTextoAvatar;
